export const SHOW_TREND_CONSUME_SUCCESS = 'SHOW_TREND_CONSUME_SUCCESS';
export const SHOW_TREND_CONSUME_FAILURE = 'SHOW_TREND_CONSUME_FAILURE';

export const SHOW_TREND_DEMAND_SUCCESS = 'SHOW_TREND_DEMAND_SUCCESS';
export const SHOW_TREND_DEMAND_FAILURE = 'SHOW_TREND_DEMAND_FAILURE';

export const SHOW_TREND_LOAD_FACTOR_SUCCESS = 'SHOW_TREND_LOAD_FACTOR_SUCCESS';
export const SHOW_TREND_LOAD_FACTOR_FAILURE = 'SHOW_TREND_LOAD_FACTOR_FAILURE';

export const SHOW_TREND_AVERAGE_SUCCESS = 'SHOW_TREND_AVERAGE_SUCCESS';
export const SHOW_TREND_AVERAGE_FAILURE = 'SHOW_TREND_AVERAGE_FAILURE';

export const SHOW_TREND_CO2_SUCCESS = 'SHOW_TREND_CO2_SUCCESS';
export const SHOW_TREND_CO2_FAILURE = 'SHOW_TREND_CO2_FAILURE';
